import React from 'react';
import { useSelector } from 'react-redux';
import { FLOWS_ENUM } from '../../common/enums';
import { selectUpdatedPermitData } from '../../store/slices/update/updateSelectors';
import { ApplicationData } from 'src/types/flow';
import { RegistrantPage } from 'src/components/pages/RegistrantPage';
import { updatePermitData } from 'src/store/slices/update/updateSlice';

const UpdateRegistrant = () => {
  const data = useSelector(selectUpdatedPermitData) as ApplicationData;

  return (
    <RegistrantPage
      data={data}
      flow={FLOWS_ENUM.UPDATE_CERTIFICATE}
      updatePermitData={updatePermitData}
    />
  );
};

export default UpdateRegistrant;
